import { create } from 'zustand';

import { PaginationSortField } from '@pflegia/types/common/job-position/pagination-sort-field';

export interface JobListSortStore {
  sort: PaginationSortField;
  setSort: (sort: PaginationSortField) => void;
}

const initialState = {
  sort: PaginationSortField.Score,
};

export const useJobListSortStore = create<JobListSortStore>(set => ({
  ...initialState,
  setSort: (sort: PaginationSortField) => set({ sort }),
}));
